import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  outside: {
    backgroundColor: "#6C63FF",
    minHeight: "100vh",
    padding: "50px",
  },

  centerDiv: {
    textAlign: "center",
  },
}));

export default useStyles;
